import React, { useContext, useEffect, useState } from 'react'
import NavbarComponent from '../../component/Navbar'
import { Button, Col, Container, Row, Tab, Tabs } from 'react-bootstrap'
import AuthContext from '../../auth/Context/AuthContext';
import axios from '../../adapters/API/axios';
import { GoInfo, GoPencil } from 'react-icons/go';
import { useNavigate } from 'react-router-dom';
import { IoPersonAdd } from "react-icons/io5";
import ModalTambahKaryawan from '../../component/Modal/ModalTambahKaryawan';
import ModalEditKaryawan from '../../component/Modal/ModalEditKaryawan';
import Swal from 'sweetalert2';
import { AgGridReact } from 'ag-grid-react';
import {
    AllCommunityModule,
    ModuleRegistry,
    colorSchemeLightCold,
    themeQuartz
} from 'ag-grid-community';
import Divisi from '../Divisi';
import { useMediaQuery } from 'react-responsive';

function DataKaryawan() {

    const { tokens } = useContext(AuthContext);
    const [listUser, setListUser] = useState([]);
    const tokenUser = tokens?.token;
    const navigate = useNavigate();
    const handleDetail = (data) => {
        navigate('/detail-karyawan/' + data.id)
    };
    const [showAddKaryawan, setShowAddKaryawan] = useState(false);
    const handleShowAddKaryawan = () => {
        setShowAddKaryawan(true);
    }
    const [showEditKaryawan, setShowEditKaryawan] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState()
    const handleShowEditKaryawan = (row) => {
        setShowEditKaryawan(true);
        setSelectedEmployee(row)
    }

    useEffect(() => {
        if (tokenUser !== undefined) fetchListUser()
    }, [tokenUser]);

    const isMobile = useMediaQuery({ maxWidth: 767 });

    const fetchListUser = () => {
        axios.get(`/api/users/`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {

                const nonSuperusers = res.data.filter(user =>
                    !user.groups.some(group => group.name === "superuser")
                );

                // Set the filtered list to state
                setListUser(nonSuperusers);
            }).catch(err => {

                if (err.response?.status === 401) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Sesi Anda telah berakhir. Silahkan Login kembali.',
                        confirmButtonText: 'Login',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            navigate('/');
                        }
                    });

                } else (console.log(err))
            })
    };


    ModuleRegistry.registerModules([AllCommunityModule]);

    const themeLightCold = themeQuartz.withPart(colorSchemeLightCold);

    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        if (listUser && listUser.length > 0) {
            const dataTableFilter = listUser.map(({ ...rest }) => rest);

            setRowData(
                dataTableFilter.map((data) => {

                    return {
                        ...data,
                        name: data?.first_name + ' ' + data?.last_name,
                        division: data?.groups[0].name ? data?.groups[0].name : '',
                    };
                })
            );
        }
    }, [listUser]);

    const colDefs = [
        {
            field: "detail",
            headerName: 'Detail',
            width: 120,
            pinned: 'left',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                        onClick={() => handleDetail(row?.data)}
                    >
                        <GoInfo
                            size={20}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                );
            },
        },
        {
            field: "username",
            headerName: 'User Name',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.username}
                    </div>
                );
            },
        },
        {
            field: "name",
            headerName: 'Nama',
            sort: 'asc',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.name}
                    </div>
                );
            },
        },
        {
            field: "division",
            headerName: 'Divisi',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.division}
                    </div>
                );
            },
        },
        {
            field: "ubah",
            headerName: 'Ubah',
            width: 100,
            pinned: 'right',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                        onClick={() => handleShowEditKaryawan(row?.data)}
                    >
                        <GoPencil
                            size={20}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                );
            },
        },
    ];

    const defaultColDef = {
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true
    };

    const [tableHeight, setTableHeight] = useState(window.innerHeight - 200); // Initial height

    useEffect(() => {
        const updateHeight = () => {
            setTableHeight(window.innerHeight - 200); // Adjust as needed
        };

        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);


    return (
        <>
            <NavbarComponent />
            <Container>
                <Tabs
                    defaultActiveKey="karyawan"
                    id="justify-tab-example"
                    className="mb-3"
                    justify
                >
                    <Tab eventKey="karyawan" title="Karyawan" >
                        <div>
                            <Button
                                id='actionButtonTabel'
                                variant='btn'
                                style={{ color: 'white', fontSize: '14px' }}
                                onClick={handleShowAddKaryawan}
                            >
                                Tambah <IoPersonAdd size={15} />
                            </Button>
                        </div>
                        <div style={{ height: tableHeight }}>
                            <AgGridReact
                                theme={themeLightCold}
                                rowData={rowData}
                                columnDefs={colDefs}
                                defaultColDef={defaultColDef}
                                pagination={isMobile ? false : true}
                                rowHeight={25}
                                paginationPageSize={25}
                                paginationPageSizeSelector={[10, 25, 50, 100]}
                            />
                        </div>
                    </Tab>
                    <Tab eventKey="divisi" title="Divisi">
                        <Divisi />
                    </Tab>
                </Tabs>
            </Container>


            <ModalTambahKaryawan
                showAddKaryawan={showAddKaryawan}
                setShowAddKaryawan={setShowAddKaryawan}
                fetchListUser={fetchListUser}
            />
            <ModalEditKaryawan
                showEditKaryawan={showEditKaryawan}
                setShowEditKaryawan={setShowEditKaryawan}
                selectedEmployee={selectedEmployee}
                fetchListUser={fetchListUser}
            />
        </>
    )
}

export default DataKaryawan
